import useSubscriptionValidation from './validateBilling';

const ValidateSubscriptonStyle = (style = {}) => {
    const isValidSubscription = useSubscriptionValidation();
    return isValidSubscription ? style : { filter: 'grayscale(1)' };
};

export default ValidateSubscriptonStyle;
